import { jsPDF } from "jspdf";
import moment from "moment";
//import moment from "moment";

var pageWidth = 210;
var pageHeight = 297;
var pageNumber = 1;

var start = 10;
var end = 200;

var normalFontSize = 16;
var mediumFontSize = 14;

var lineHeight = Math.floor(normalFontSize / 2);
var currentY = 2 * lineHeight - 10;
var xCenter = Math.floor(pageWidth / 2);

let doc = new jsPDF("p", "mm", [pageWidth, pageHeight]);
// const trimString = (str, separator = " ") => {
//   let maxLen = 32;
//   if (str.length <= maxLen) return str;
//   return str.substr(0, str.lastIndexOf(separator, maxLen));
// };
const checkForNextPage = taxAreaHeight => {
  if (currentY > 297 - taxAreaHeight - 12) {
    doc.addPage();
    pageNumber += 1;
    doc.text(`Page No:${pageNumber}`, xCenter, 294, { align: "center" });
    currentY = 15;
    if (!taxAreaHeight) {
      debugger;
      horizLine();
    }
  }
};

const priceToWords = (price) => {

  const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const teens = ['', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  function convertLessThanThousand(num) {
    if (num === 0) {
      return '';
    } else if (num < 10) {
      return ones[num];
    } else if (num < 20) {
      return teens[num - 10];
    } else if (num < 100) {
      return tens[Math.floor(num / 10)] + ' ' + convertLessThanThousand(num % 10);
    } else {
      return ones[Math.floor(num / 100)] + ' hundred ' + convertLessThanThousand(num % 100);
    }
  }

  if (isNaN(price) || price < 0 || price > 999999.99) {
    return 'Invalid input';
  }

  const dollars = Math.floor(price);
  const cents = Math.round((price - dollars) * 100);

  let result = '';

  if (dollars > 0) {
    result += convertLessThanThousand(dollars) + '';
  }

  if (cents > 0) {
    result += (dollars > 0 ? ' and ' : '') + convertLessThanThousand(cents) + ' cents';
  }

  return result.trim();
};


const printInvoice = (invoice, customerDetails) => {

  currentY = 2 * lineHeight - 10;
  doc = new jsPDF("p", "mm", [pageWidth, pageHeight]);

  doc.setFontSize(36);
  nextLine(2);
  fontType("bold");
  //doc.addImage("img/logo-print.png", "png", 50, currentY, 50, 12);
  doc.text(`Dietbux`, start, currentY);

  doc.setTextColor(0, 171, 200);
  doc.text(`INVOICE`, start + 135, currentY);

  doc.setTextColor(0, 0, 0);

  nextLine(.7);
  doc.setFontSize(mediumFontSize - 3);
  doc.setTextColor(131, 127, 129);
  doc.text(`BILL TO`, start, currentY);


  doc.setTextColor(0, 0, 0);
  doc.setFontSize(mediumFontSize - 3);

  doc.text(`Invoice No`, start + 140, currentY);


  fontType("normal");
  doc.text(`: ${invoice.invoiceNo}`, start + 140 + 25, currentY);

  fontType("bold");
  doc.text(`Invoice Date`, start + 135, currentY + 5);


  fontType("normal");
  doc.text(`: ${moment(new Date(parseInt(invoice.createdAt))).format("DD MMM YYYY")}`, start + 140 + 25, currentY + 5);

  nextLine(.7);
  doc.setTextColor(0, 171, 200);
  fontType("bold");
  debugger
  doc.text(`${invoice.customerInfo.firstnameEn} ${invoice.customerInfo.lastnameEn}`, start, currentY);
  nextLine(.7);
  doc.text(`Phone :${invoice?.user?.phone}`, start, currentY);


  nextLine(.7);
  fontType("normal");
  doc.text(`VAT Number : -`, start, currentY);

  nextLine(1);

  doc.setTextColor(0, 0, 0);
  let address = null;
  if (customerDetails.addressDetails.length) {
    address = customerDetails.addressDetails.find(x => x.is_default)
    if (!address) {
      address = customerDetails.addressDetails[0];
    }
  }

  doc.text(`Area : ${address?.area?.nameEn}, Block : ${address?.block?.block}`, start, currentY);
  nextLine(.5);
  doc.text(`House No : ${address?.house_number}, Jedha : ${address?.jedha ?? '-'}`, start, currentY);

  doc.setDrawColor(131, 127, 129);

  doc.line(130, currentY, 200, currentY);



  nextLine(.6);
  doc.text(`Floor : ${address?.building_number ?? '-'}, Apartment No : ${address?.apartment_number ?? '-'} `, start, currentY);

  doc.text(`Total Amount`, start + 167, currentY + 2);

  fontType("bold");

  fontSize(mediumFontSize + 8);
  doc.text(`${invoice.total.toFixed(3)} KD`, start + 155, currentY + 12);

  nextLine(.8);

  fontSize(mediumFontSize);

  doc.text(`Phone`, start, currentY);
  fontType("normal");
  doc.text(`:`, start + 18, currentY);
  debugger

  doc.text(`+956${invoice.user.phone} `, start + 18 + 3, currentY);
  nextLine(.8);
  fontType("bold");
  doc.text(`Email `, start, currentY);
  fontType("normal");
  doc.text(`:`, start + 18, currentY);
  let email = "";
  if (invoice.user.email)
    email = invoice.user.email;
  else if (customerDetails.user.email)
    email = customerDetails.user.email
  doc.text(`${email ? email : '-'} `, start + 18 + 3, currentY);

  nextLine(1.25);

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(.5)
  doc.line(start, currentY, start + 50, currentY);
  doc.line(start + 55, currentY, start + 190, currentY);

  nextLine(.6);
  fontSize(mediumFontSize - 4);
  fontType("bold");
  doc.text(`#`, start + 10, currentY);
  doc.text(`Product`, start + 20, currentY);


  doc.text(`Quantity`, start + 70, currentY);
  doc.text(`Unit Price`, start + 95, currentY);
  doc.text(`Total`, start + 120, currentY);
  doc.text(`Discount`, start + 145, currentY);
  doc.text(`Amount`, start + 170, currentY);


  nextLine(.5);
  doc.line(start, currentY, start + 50, currentY);
  doc.line(start + 55, currentY, start + 190, currentY);

  fontSize(mediumFontSize);

  fontType("normal");
  fontSize(mediumFontSize - 4);
  doc.setDrawColor(131, 127, 129);
  doc.setLineWidth(.2)

  if (invoice.order) {
    if (invoice.order.products) {
      invoice.order.products.forEach(function (item, index) {
        debugger
        nextLine(1.2);

        doc.setTextColor(131, 127, 129);
        doc.text(String(index + 1), start + 10, currentY);
        doc.setTextColor(0, 0, 0);
        doc.text(`${item.productInfo.nameEn} `, start + 20, currentY);


        doc.text(`${item.quantity}`, start + 70, currentY);

        doc.text(`${item.productInfo.price.toFixed(3)}`, start + 95, currentY);
        doc.text(`${(item.productInfo.price * item.quantity).toFixed(3)}`, start + 120, currentY);

        // Calculate item discount (proportional to total invoice discount)
        let itemTotal = item.productInfo.price * item.quantity;
        let itemDiscount = invoice.discount ? (itemTotal * invoice.discount / invoice.amount) : 0;
        doc.text(`${itemDiscount.toFixed(3)}`, start + 145, currentY);

        let itemAmount = itemTotal - itemDiscount;
        doc.text(`${itemAmount.toFixed(3)}`, start + 170, currentY);

        nextLine(.8);
        if (index != 4) {
          doc.line(start, currentY, start + 50, currentY);
          doc.line(start + 55, currentY, start + 190, currentY);
        }
        checkForNextPage(0);
      })
    }
  }
  else {


    nextLine(1.2);
    doc.setTextColor(131, 127, 129);
    doc.text(String(), start + 10, currentY);
    doc.setTextColor(0, 0, 0);
    doc.text(`${invoice.note} `, start + 20, currentY);


    doc.text(`1`, start + 75, currentY);

    doc.text(`${invoice.amount}`, start + 95, currentY);
    doc.text(`${invoice.amount}`, start + 120, currentY);

    // Display discount
    let discountAmount = invoice.discount || 0;
    doc.text(`${discountAmount.toFixed(3)}`, start + 145, currentY);

    // Calculate final amount (amount - discount)
    let finalAmount = invoice.amount - discountAmount;
    doc.text(`${finalAmount.toFixed(3)}`, start + 170, currentY);

    nextLine(.8);
    if (start != 4) {
      doc.line(start, currentY, start + 50, currentY);
      doc.line(start + 55, currentY, start + 190, currentY);
    }
  }


  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(.5)
  doc.line(start, currentY, start + 50, currentY);
  doc.line(start + 55, currentY, start + 190, currentY);


  // if (!invoice.order) {

  //   doc.setFillColor(189, 189, 189);
  //   doc.rect(start, currentY, end - start, 10, "F");
  //   nextLine(0.5);
  //   doc.setTextColor(255, 255, 255);
  //   fontType("bold");


  //   fontType("medium");


  // } else {
  //   nextLine(1);

  //   horizLine();
  //   doc.line(start + 14.5, currentY, start + 14.5, currentY + 6.5); //vertical line on the headers table
  //   doc.line(start + 126, currentY, start + 126, currentY + 6.5);
  //   doc.line(start + 160, currentY, start + 160, currentY + 6.5);

  //   nextLine(0.5);

  //   fontType("bold");
  //   doc.text("#", start + 4, currentY);
  //   doc.text("Product Name", start + 16, currentY);
  //   doc.text("Qty ", start + 128, currentY);
  //   doc.text("Price", start + 162, currentY);

  //   fontType("medium");

  //   nextLine(0.3);
  //   horizLine();

  // }
  doc.setTextColor(0, 0, 0);
  // let deliveryCharge = order.pricing.deliveryCharge || 0
  // if (invoice.order) {

  //   if (invoice.order.products) {
  //     invoice.order.products.forEach(function (item, index) {
  //       nextLine(0.5);
  //       // values
  //       doc.text(String(index + 1), start + 4, currentY);
  //       doc.text(trimString(item.productInfo.nameEn), start + 16, currentY);
  //       doc.text(String(item.quantity), start + 128, currentY);
  //       doc.text(
  //         String(item.productInfo.price.toFixed(3)) + "" || "-",
  //         start + 162,
  //         currentY
  //       );

  //       //vertical line on the left side of a  value
  //       doc.line(start + 14.5, currentY - 3.5, start + 14.5, currentY + 1.5);
  //       doc.line(start + 126, currentY - 3.5, start + 126, currentY + 1.5);
  //       doc.line(start + 160, currentY - 3.5, start + 160, currentY + 1.5);

  //       nextLine(0.1);
  //       horizLine();

  //     });
  //   }
  // }

  // if (!invoice.order) {
  //   doc.text("Item Name", start + 5, currentY);
  //   doc.text("Quantity", xCenter, currentY, { align: "center" });
  //   doc.text("Price", end - start, currentY, { align: "right" });
  // }
  nextLine(2);
  doc.setTextColor(0, 0, 0);
  fontType("normal");

  doc.addImage(invoice.qrCode, "png", start, currentY, 30, 30);
  nextLine(.8);
  fontSize(mediumFontSize - 4);
  // doc.text("Total Before VAT :", end - 30, currentY, { align: "right" });

  // doc.text(`${invoice.amount.toFixed(3)} KD`, end, currentY, { align: "right" });
  nextLine(.3);

  doc.setDrawColor(131, 127, 129);
  //doc.setLineWidth(.2)

  //doc.line(end - 59, currentY, end, currentY);
  nextLine(.6);
  // doc.text("Total  VAT :", end - 40, currentY, { align: "right" });
  //doc.text(`0 KD`, end, currentY, { align: "right" });
  nextLine(.3);

  doc.line(end - 59, currentY, end, currentY);
  nextLine(.6);
  fontType("bold");

  doc.text("Subtotal :", end - 48, currentY, { align: "right" });
  doc.text(`${invoice.amount?.toFixed(3)}`, end, currentY, { align: "right" });
  nextLine(.7);

  // Add discount line
  let discountAmount = invoice.discount || 0;
  doc.text("Discount :", end - 48, currentY, { align: "right" });
  doc.text(`${discountAmount.toFixed(3)}`, end, currentY, { align: "right" });
  nextLine(.7);

  // Calculate final amount after discount
  let finalAmount = invoice.amount - discountAmount;
  doc.text("Total :", end - 48, currentY, { align: "right" });
  doc.text(`${finalAmount.toFixed(3)}`, end, currentY, { align: "right" });
  nextLine(.7);

  doc.text(`Amount in words:`, start + 2, currentY);

  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(.5)

  doc.line(end - 65, currentY, end, currentY);
  nextLine(.7);
  doc.setTextColor(0, 0, 0);
  fontType("normal");
  doc.text(`${priceToWords(finalAmount)}`, start + 2, currentY);

  fontType("bold");
  fontSize(mediumFontSize);
  nextLine(.2);
  doc.text("Due Amount :", end - 32, currentY, { align: "right" });
  doc.text(`${finalAmount.toFixed(3)}`, end, currentY, { align: "right" });

  nextLine(1.5);
  doc.setDrawColor(131, 127, 129);
  doc.setLineWidth(.2)
  doc.line(end - 50, currentY, end - 10, currentY);
  nextLine(.5);

  fontSize(mediumFontSize - 4);
  doc.textWithLink(`Terms & Conditions`, start, currentY, { url: "https://dietbux.com/en/terms" });
  fontType("normal");
  fontSize(mediumFontSize - 5);
  //doc.text(`Your conditions should place here`, start + 40, currentY);

  fontSize(mediumFontSize - 4);
  fontType("bold");
  doc.text(`Seal and Signature`, end - 45, currentY);

  nextLine(.8);
  doc.line(start, currentY, start + 190, currentY);
  nextLine(.8);

  fontType("normal");
  doc.addImage("img/invoice/phone-call.png", "png", start, currentY - 3.5, 6, 6);
  doc.setTextColor(0, 171, 200);
  doc.text(`+965 9876543210`, start + 10, currentY);

  doc.addImage("img/invoice/world.png", "png", start + 80, currentY - 3.5, 6, 6);
  doc.text(`dietbux.com`, start + 90, currentY);


  doc.addImage("img/invoice/placeholder.png", "png", start + 140, currentY - 3.5, 6, 6);
  doc.text(`Omar Bin Abdulaziz`, start + 150, currentY);


  doc.setDrawColor(0, 171, 200);
  doc.setLineWidth(.3)
  nextLine(.4);
  doc.line(start + 10, currentY, start + 50, currentY);
  doc.line(start + 90, currentY, start + 130, currentY);
  doc.text(`St Al Zahara, Ahmedi,`, start + 150, currentY);
  nextLine(.6);

  doc.addImage("img/invoice/email.png", "png", start, currentY - 3.5, 6, 6);
  doc.text(`contact@dietbux.com`, start + 10, currentY);


  doc.addImage("img/invoice/document.png", "png", start + 80, currentY - 3.5, 6, 6);
  doc.text(`TAX NO : 300123492800003`, start + 90, currentY);
  doc.text(`12812, Kuwait`, start + 150, currentY);

  doc.setFillColor(0, 171, 200);
  nextLine(2.4);
  doc.rect(0, currentY, end + 20, 10, "F");



  doc.save(`Invoice_${invoice.invoiceNo}.pdf`);
};

const fontType = (type) => doc.setFont(undefined, type);
const horizLine = () => {
  doc.line(0, currentY, pageWidth, currentY);
};
const fontSize = (size) => doc.setFontSize(size);
const nextLine = (numberOfLines) =>
  (currentY += numberOfLines * lineHeight + 1);
// const seperator = (item) => {
//   console.log(item)
//   doc.setDrawColor(210, 210, 210);
//   doc.line(start, currentY, end, currentY);
// };
// const getFullAddress = (invoice) => {
//   let fullAddress = invoice.customerInfo.addressLine1.split(',');
//   if (fullAddress.length > 3) {
//     let addressLine1 = fullAddress[0];
//     let addressLine2 = fullAddress[2];
//     fullAddress = [addressLine1, addressLine2]
//     if (fullAddress.length > 4) {
//       fullAddress = [addressLine1, addressLine2]
//     }
//   }
//   return fullAddress;
// }

export { printInvoice };
